module.exports = __webpack_public_path__ + "img/prepaid100-pl.f5e1158f.svg";